import { useMutation, useQueryClient } from '@tanstack/react-query'

import chatService, { type LinkPlayerToRoomDto } from '../services'
import { chatKeys } from '../../keys'

export function useMutationLinkPlayer(roomId: string) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (data: LinkPlayerToRoomDto) =>
			chatService.linkPlayerToRoom(roomId, data),
		onSuccess: () => {
			// Invalidate room query to refresh player data
			queryClient.invalidateQueries({ queryKey: chatKeys.room(roomId) })
			queryClient.invalidateQueries({ queryKey: chatKeys.rooms() })
		},
	})
}

export function useMutationUnlinkPlayer(roomId: string) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: () => chatService.unlinkPlayerFromRoom(roomId),
		onSuccess: () => {
			// Invalidate room query to refresh player data
			queryClient.invalidateQueries({ queryKey: chatKeys.room(roomId) })
			queryClient.invalidateQueries({ queryKey: chatKeys.rooms() })
		},
	})
}
